<span *ngIf="status === 'queued'" class="badge badge-info">{{ status }}</span>
<span *ngIf="status === 'processing'" class="badge badge-warning">{{ status }}</span>
<span *ngIf="status === 'finished'" class="badge badge-success">{{ status }}</span>
<span *ngIf="status === 'error'" class="badge badge-error">{{ status }}</span>
